import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
export function usePushModal(modalType) {
    const dispatch = useDispatch();
    return useCallback((params = {})=>{
        yieldToMain(()=>{
            dispatch(pushModal(modalType, {
                wrapInModal: false,
                params
            }));
        });
    }, [
        dispatch,
        modalType
    ]);
}

//# sourceMappingURL=usePushModal.js.map